import { useMatch } from 'react-router-dom';

import {
  PROFILE_PAGE,
  PROFILE_PAGE_URL,
  SHAREABLE_PROFILE_PAGE,
  SHAREABLE_PROFILE_PAGE_URL,
  CREATE_RESUME_PAGE,
  CREATE_RESUME_PAGE_URL,
} from 'src/components/Router';
import type { Page } from 'src/types';

export const usePage = (): Page => {
  const profilePageMatch = useMatch(PROFILE_PAGE_URL);
  const shareableProfilePageMatch = useMatch(SHAREABLE_PROFILE_PAGE_URL);
  const createResumePageMatch = useMatch(CREATE_RESUME_PAGE_URL);

  // Note: Order important - most specific routes first!
  if (createResumePageMatch) {
    return CREATE_RESUME_PAGE;
  } else if (profilePageMatch) {
    return PROFILE_PAGE;
  } else if (shareableProfilePageMatch) {
    return SHAREABLE_PROFILE_PAGE;
  }

  return PROFILE_PAGE;
};
